import type { Meta, StoryFn } from '@storybook/react';

import { FieldValueList, NoValue, Status, Text } from '@pega/cosmos-react-core';

export default {
  title: 'Core/NoValue',
  component: NoValue
} as Meta;

export const Base: StoryFn = () => {
  return <NoValue />;
};

export const InFVL: StoryFn = () => {
  return (
    <FieldValueList
      fields={[
        {
          id: 'dynamic',
          name: 'Name',
          value: <NoValue />
        },
        {
          id: 'id',
          name: 'ID',
          value: (
            <Text variant='h1' as='span'>
              C-1234
            </Text>
          )
        },
        {
          id: 'status',
          name: 'Status',
          value: <Status variant='pending'>pending</Status>
        }
      ]}
    />
  );
};
